/**
 * Available fonts for theme customization.
 * These fonts are loaded from Google Fonts.
 */
export const AVAILABLE_FONTS = [
  { name: "Inter", value: "Inter" },
  { name: "Roboto", value: "Roboto" },
  { name: "Open Sans", value: "Open Sans" },
  { name: "Poppins", value: "Poppins" },
  { name: "Montserrat", value: "Montserrat" },
  { name: "Lato", value: "Lato" },
  { name: "Nunito", value: "Nunito" },
  { name: "Raleway", value: "Raleway" },
  { name: "Source Sans 3", value: "Source Sans 3" },
  { name: "Work Sans", value: "Work Sans" }
] as const;

export type FontName = (typeof AVAILABLE_FONTS)[number]["value"];

export const DEFAULT_FONT_FAMILY = "Inter";
export const DEFAULT_FONT_FAMILY_HEADINGS = "Inter";

const loadedFonts = new Set<string>();

/**
 * Build the Google Fonts URL for a given font name.
 * @param fontName
 */
function buildGoogleFontUrl(fontName: string): string {
  const encodedFont = fontName.replaceAll(" ", "+");
  return `https://fonts.googleapis.com/css2?family=${encodedFont}:wght@400;500;600;700&display=swap`;
}

/**
 * Dynamically loads a Google Font.
 * Only loads each font once per session.
 * @param fontName
 */
export function loadGoogleFont(fontName: string): void {
  if (!fontName || loadedFonts.has(fontName)) {
    return;
  }

  const isAvailable = AVAILABLE_FONTS.some((f) => f.value === fontName);
  if (!isAvailable) {
    console.warn(`Font "${fontName}" is not in the available fonts list.`);
    return;
  }

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = buildGoogleFontUrl(fontName);
  document.head.append(link);

  loadedFonts.add(fontName);
}

/**
 * Build the full CSS font-family string with fallbacks.
 * @param fontName
 */
export function buildFontFamilyString(fontName: string): string {
  return `"${fontName}", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`;
}
